import React, { useEffect, useContext, useRef } from 'react';

import {
    LinearProgress,
    Grid
} from '@material-ui/core';

import {
    PageHeader
} from '../../../common';

import {
    LogsGrid
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { NavContext, NavRoutes } from '../../../contexts/NavContext';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    contentGrid: {
        marginTop: theme.spacing(1),
        width: "100%",
        height: "100%"
    }
}));

const PageContent = (props) => {
    const classes = useStyles();

    const {
        state,
        pageIsReady,
        setPageIsReady,
        isBusy,
        setIsBusy,
        getLogsTableAsync,
        loadLogsTableRowsAsync,
        createGridDataSource,
        getGridDataSource,
        loadMoreRows
    } = useContext(PageContext);

    const {
        navigateTo
    } = useContext(NavContext);

    const {
        table
    } = state;

    const loadRowsHandler = async (sortAndFilter, success) => {
        setIsBusy({ loadMore: true });
        const bundle = await loadLogsTableRowsAsync(sortAndFilter);
        success(bundle ? bundle.items : [], bundle ? bundle.totalItems : 0);
        setIsBusy({ loadMore: false });
    }

    const loadMoreHandler = (pageIndex, pageSize) => {
        loadMoreRows(pageIndex, pageSize);
    }

    const windowResizeHandler = (e) => {
        if (containerDiv.current) {
            const htmlDiv = containerDiv.current;
            const height = window.innerHeight - (htmlDiv.offsetTop + 64);
            htmlDiv.style.height = `${height}px`;
        }
    }

    useEffect(() => {
        setPageIsReady(false);
        getLogsTableAsync();
    }, []);

    useEffect(() => {
        if (table) {
            setIsBusy({ loadMore: true });
            createGridDataSource({
                table: table,
                pageSize: 100,
                onLoadRows: loadRowsHandler
            });
            setPageIsReady(true);
        }
    }, [table]);

    const containerDiv = useRef(null);
    useEffect(() => {
        if (pageIsReady && containerDiv.current) {
            const htmlDiv = containerDiv.current;
            const height = window.innerHeight - (htmlDiv.offsetTop + 64);
            htmlDiv.style.height = `${height}px`;
        }
    }, [pageIsReady]);

    useEffect(() => {
        window.addEventListener("resize", windowResizeHandler);
        return () => {
            window.addEventListener("resize", null);
        }
    }, []);

    return (
        <>
            {pageIsReady ?
                <Grid container spacing={3} className={classes.root}>
                    <Grid item xs={12}>
                        <PageHeader
                            title="Logs"
                            subtitle="Application operations"
                            disabled={isBusy()}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <div ref={containerDiv}>
                            <LogsGrid
                                disabled={isBusy()}
                                className={classes.contentGrid}
                                dataSource={getGridDataSource()}
                                onLoadMore={loadMoreHandler}
                            />
                        </div>
                    </Grid>
                </Grid>
                :
                <LinearProgress />
            }
        </>
    );
}

export const LogsPage = () => {

    return (
        <PageProvider>
            <PageContent />
        </PageProvider>
    );
}